import { render, staticRenderFns } from "./transition-collapse.vue?vue&type=template&id=d8376f2a"
import script from "./transition-collapse.vue?vue&type=script&lang=js"
export * from "./transition-collapse.vue?vue&type=script&lang=js"
import style0 from "./transition-collapse.vue?vue&type=style&index=0&id=d8376f2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports